import * as React from "react";

import { Button } from "semantic-ui-react";

import { ActionableTask } from "../models";

import { Link } from "redux-little-router";

export const BookAppointment = (task: ActionableTask) => (
    !task.completed && !task.cancelled &&
    (
        <Link
            href={`/actions/${task.ohCaseId}/${task.id}/choose-and-book`}
        >
            <Button content="Book appointment" />
        </Link>
    )
);
